<template functional>
  <div class="video-tile" @click="listeners['openVideo'](props.video)">
    <div
      class="video-tile__background"
      :style="
        `background-image: url(${props.backgroundImg}), linear-gradient(${props.gradient})`
      "
    >
      <div class="video-tile__overlay"></div>
      <div class="video-tile__details">
        <div class="video-tile__icon-wrapper">
          <i class="material-icons video-tile__icon">play_arrow</i>
        </div>
      </div>
      <div class="video-tile__extended-details">
        <div class="data video-tile__title">
          {{ props.video.name }}
          <p class="data video-tile__instructor">
            {{ props.video.instructor.name }}
          </p>
        </div>
        <div class="video-tile__duration-wrapper">
          <p class="data video-tile__duration">{{ props.duration }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoTile',
  props: {
    video: {
      type: Object,
      required: true,
    },
    backgroundImg: {
      type: String,
      required: true,
    },
    gradient: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.video-tile {
  text-align: left;
  background-color: var(--light-gray);
  color: var(--white);
  text-decoration: none;
  width: 100%;
  &:hover {
    cursor: pointer;
    .video-tile__overlay {
      opacity: 1;
    }
  }
  &__background {
    min-height: 200px;
    height: 200px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    z-index: 1;
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    z-index: -1;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__details {
    width: 100%;
    padding: 30px 25px 15px 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
    z-index: 1;
    align-items: center;
    justify-content: center;
  }
  &__icon-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__lead {
    font-weight: 700;
  }
  &__title {
    font-size: 1rem;
  }
  &__instructor {
    font-weight: normal;
    font-size: 0.8rem;
  }
  &__course-lead {
    font-size: 0.7rem !important;
  }
  &__course {
    font-size: 0.8rem;
  }
  &__extended-details {
    display: flex;
    margin: 10px 0 0 0;
    padding: 0 10px;
    position: relative;
  }
  &__duration-wrapper {
    margin: 0 0 0 auto;
  }
  &__duration {
    white-space: nowrap;
    background: black;
    padding: 5px 10px;
    font-size: 0.8rem;
    border-radius: 10px;
  }
  .lead {
    font-size: 0.8rem;
  }
  &__icon {
    font-size: 50px;
  }
}
</style>
